import React from 'react';
import { css } from '@emotion/react';

export const OptionalInfoBox = ({ finalStep }: { finalStep?: boolean }) => {
	return (
		<div
			css={css`
				background: #fffaf0;
				border: 1px solid #ffca6a;
				border-radius: 12px;
				border-radius: 12px;
				padding: 12px 20px;
				color: #b37300;
				font-size: 14px;
				line-height: 20px;
				margin-top: 20px;
			`}
		>
			{finalStep ? (
				<>
					Nevyplněné údaje je potřeba doplnit <strong>nejpozději 14 dnů před vystoupením.</strong>
				</>
			) : (
				<>
					Tyto údaje je možné doplnit <strong>nejpozději 14 dnů před vystoupením.</strong>
				</>
			)}

			<div
				css={css`
					padding-top: 8px;
					font-size: 13px;
				`}
			>
				<strong>Pozor:</strong> Pokud zadáte do vstupů pouze znak mezery, je potřeba je odstranit.
			</div>
		</div>
	);
};
